<template>
  <div class="row m-0">
    <transition name="fade">
      <delete-contact-popup :contact="contactDelete" v-if="isDelete" @close="close"></delete-contact-popup>
      <edit-contact v-if="isEdit" @close="close" :contact="contact"></edit-contact>
    </transition>
    <div class="col-12 mb-3 px-0 pb-3 border-bottom">
      <div class="row m-0 align-items-center">
        <div class="col p-0">
          <h4 class="mb-0">Contacts</h4>
        </div>
        <div class="col-auto p-0 text-end">
          <button class="btn btn-primary px-2 px-md-3 px-lg-5" @click="addContact">
            <div class="row m-0 align-items-center">
              <div class="col-auto p-0 d-flex">
                <ios-add-icon />
              </div>
              <div class="col ps-1">
                Add <span class="d-none d-md-inline-flex">Contact</span>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
    <div class="col-12 p-3 p-md-4 white_bg">
      <div class="row m-0" v-if="Object.keys(activeContacts).length === 0" >
        <div class="col-12 p-0">
          Your contact list is empty. Please <span class="link_colour cursor" @click="addContact">add</span> some contacts.
        </div>
      </div>
      <div class="row m-0" v-else>
        <div class="col-12 p-0">
          <div class="row m-0 py-2 mb-2 border-bottom align-items-center cursor" v-for="(contact, key) in activeContacts" :key="key">
            <div class="col-10 p-0" @click="edit(contact)">
              <div class="row m-0">
                <div class="col-md-6 p-0">
                  {{contact.firstname}} {{contact.lastname}}
                </div>
                <div class="col-md-5 p-0">
                  {{contact.email}}
                </div>
              </div>
            </div>
            <div class="col-2 p-0 text-end">
              <div class="row m-0 justify-content-end">
                <div class="col-6 col-md-auto pe-0 small" @click="edit(contact)">
                  <ios-create-icon />
                </div>
                <div class="col-6 col-md-auto pe-0 small" @click="remove(contact, key)">
                  <ios-trash-icon />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'Contacts',
  components: {
    'delete-contact-popup': () => import('../components/DeleteContactPopup.vue'),
    'edit-contact': () => import('../components/EditContactPopup.vue')
  },
  data () {
    return {
      isAdd: false,
      isEdit: false,
      isDelete: false,
      contactDelete: {},
      // contacts: [],
      contact: {},
      contactkey: ''
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'contacts']),
    activeContacts () {
      const obj = {}
      Object.entries(this.contacts).forEach(entry => {
        const [key, value] = entry
        if (!value.deleted) {
          obj[key] = value
          obj[key].key = key
        }
      })
      return obj
    }
  },
  methods: {
    ...mapActions(['deleteContact']),
    addContact () {
      this.$router.push('AddContact')
    },
    edit (contact) {
      this.contact = contact
      this.isEdit = true
      this.isDelete = false
      this.trusteeDelete = {}
    },
    close () {
      this.isAdd = false
      this.isEdit = false
      this.isDelete = false
      this.trusteeDelete = {}
    },
    remove (val) {
      this.contactDelete = val
      this.isDelete = true
      // this.deleteContact(val)
    }
  }
}
</script>
